<template>

    <div class="page-body">
        <v-loader size="lg" v-if="!show && !error" centered />
        <v-notice v-if="show && error" size="lg" title="Woops!" message="Unable to load page." />
        <slot v-if="show && !error"></slot>
    </div>

</template>

<style scoped lang="scss">

    .page-body {
        box-sizing: border-box;
        flex-grow: 1;
        padding: 15px;
        padding-bottom: 120px;
        position: relative;
    }

    .page.page-fixed .page-body {
        margin: 0 auto;
        max-width: $screen-xl-min;
        width: 100%;
    }

</style>

<script>

export default {

    data() {
        return {
            show: false,
            error: false,
        }
    },

    mounted() {
        this.show = false;
        this.error = false;
        this.$events.$on('pageLoaded', () => {
            this.show = true;
            this.error = false;
        });
        this.$events.$on('pageError', () => {
            this.show = true;
            this.error = true;
        });
    },

}

</script>